// Profile fields kept in the public users/{uid} document.
export const PUBLIC_USER_FIELDS = [
  "deActivated",
  "isPrivateProfile",
  "username",
  "reason",
  "cycleDays",
  "trainingSportIDs",
  "blockDays",
  "sleepGoal",
  "loadGoal",
  "weeklyLoadGoal",
  "performanceGoals",
  "healthGoals",
  "campaignCode",
  "competitionLevel",
  "inviteCode",
  "imageUrl",
  "imageUrlNormal",
  "imageUrlTiny",
  "onboardingComplete",
  "onboardingResumeStep",
  "socialMessageRead",
  "simpleWellnessSetting",
  "casualMode",
  "disableInsights",
  "hidePeakScore",
  "hideWellnessSleep",
  "isImperial",
  "autoPostTraining",
  "activityVariablePreferences",
  "adminActivityCatIDs",
  "notifySettings",
  "devicePreferences",
  "backgroundImage",
  "dismissedPlatformUpdateBanner",
  "dismissedUpdate20May",
  "customPeriodisationTypes",
  "customTrainingTypes",
  "trainingTypeColors",
  "periodisationColors",
  "twoFactorEnabled",
  "twoFactorMethod",
] as const;
